import type { ReactElement } from 'react'

import { Tooltip } from '#design-system/component/Tooltip/Tooltip'

interface FieldLabelProps {
  /** Id of the control this label describes; bound via `htmlFor`. */
  htmlFor: string
  /** Adds a decorative asterisk after the label text. The `required` attribute on the
   * input drives screen-reader announcement, not this prop. */
  required?: boolean | undefined
  /** Label text. Truncates with a Tooltip showing the full string when it overflows. */
  children: string
}

/**
 * Label row for a form field. Wraps the text in a truncation-aware Tooltip and renders
 * an optional required asterisk.
 */
export const FieldLabel = ({ htmlFor, required, children }: FieldLabelProps): ReactElement => (
  <label className="doss-field-label" htmlFor={htmlFor}>
    <Tooltip onlyShowIfReferenceTruncated title={children}>
      <span className="text">{children}</span>
    </Tooltip>
    {required ? (
      <span aria-hidden="true" className="required">
        *
      </span>
    ) : null}
  </label>
)
